// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"fbf77708","104":"0396dc9a","116":"c4f99ae5","256":"690bda8c","377":"a6fde1e6","787":"88cc02eb"}[chunkId] + ".chunk.js";
};